import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DevicesContext, IDevicesContext } from 'modules/Devices/Devices/devicesState/devicesContext';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IDevicesContext>(DevicesContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByHardwareIdLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByHardwareId1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('HardwareID1-10')}
						checked={sortBy === 'HardwareID1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByHardwareId10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('HardwareID10-1')}
						checked={sortBy === 'HardwareID10-1'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByRestaurantLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByRestaurantA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('RestaurantA-Z')}
						checked={sortBy === 'RestaurantA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByRestaurantZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('RestaurantZ-A')}
						checked={sortBy === 'RestaurantZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByCustomerLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCustomerA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CustomerA-Z')}
						checked={sortBy === 'CustomerA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByCustomerZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('CustomerZ-A')}
						checked={sortBy === 'CustomerZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
